import { ConsoleLogger } from '@skylab-shared/core';
import { PropertiesOf } from '@skylab-shared/types';
import { FormState } from './../form-state';

export abstract class FormStateHandler<TContext = {}> {
    protected readonly logger: ConsoleLogger;

    protected next!: PropertiesOf<FormStateHandler<TContext>>;

    public constructor() {
        this.logger = new ConsoleLogger(this.constructor.name);
    }

    protected abstract get formState(): FormState;

    public setNext(next: PropertiesOf<FormStateHandler<unknown>>): PropertiesOf<FormStateHandler<unknown>> {
        this.next = next;
        return next;
    }

    public process(formState: FormState, ctx: TContext): void {
        if (this.formState === formState) {
            try {
                this.handle(ctx);
            } catch (err) {
                this.logger.error(err);
            }
        } else if (this.next) {
            this.next.process(formState, ctx);
        } else {
            this.logger.info(`${FormState[formState]} not handled.`);
        }
    }

    public terminate(formState: FormState): void {
        if (this.formState === formState) {
            try {
            } catch (err) {
                this.logger.error(err);
            }
        } else if (this.next) {
            this.next.terminate(formState);
        }
    }

    protected abstract handle(ctx: TContext): void;
}
